import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Confirmação", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Tem certeza que deseja continuar?")
], -1)
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Rota")
], -1)
const _hoisted_12 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-5 col-md-5 col-sm-5 my-auto" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "col-lg-5 col-md-5 col-sm-5" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "p-3 pb-0 card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Informações")
], -1)
const _hoisted_21 = { class: "p-3 card-body" }
const _hoisted_22 = { class: "list-group" }
const _hoisted_23 = { class: "mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ni ni-delivery-fast text-white opacity-10" })
], -1)
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-1 text-sm text-dark" }, "Veículo", -1)
const _hoisted_28 = { class: "text-xs" }
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-bold-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ni ni-tag text-white opacity-10" })
], -1)
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-1 text-sm text-dark" }, "Motorista", -1)
const _hoisted_37 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" SEM MOTORISTA ")
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", null, "Atualizando", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um motorista", -1)
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-bold-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ni ni-box-2 text-white opacity-10" })
], -1)
const _hoisted_52 = { class: "d-flex flex-column" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-1 text-sm text-dark" }, "Serviços", -1)
const _hoisted_54 = { class: "text-xs" }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", {
  class: "ni ni-bold-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3\"><i class=\"ni ni-building text-white opacity-10\"></i></div><div class=\"d-flex flex-column\"><h6 class=\"mb-1 text-sm text-dark\">Rota FIXA</h6></div></div>", 1)
const _hoisted_60 = { class: "d-flex" }
const _hoisted_61 = { class: "form-check form-switch" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_63 = { class: "mb-2 border-0 list-group-item d-flex justify-content-between border-radius-lg ps-0" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"text-center shadow icon icon-shape icon-sm bg-gradient-dark me-3\"><i class=\"ni ni-building text-white opacity-10\"></i></div><div class=\"d-flex flex-column\"><h6 class=\"mb-1 text-sm text-dark\">Rota Confirmada</h6></div></div>", 1)
const _hoisted_65 = { class: "d-flex" }
const _hoisted_66 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_68 = {
  key: 1,
  class: "badge badge-lg bg-gradient-success"
}
const _hoisted_69 = { class: "mb-2 border-0 list-group-item d-flex border-radius-lg ps-0" }
const _hoisted_70 = { class: "d-flex" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-white opacity-10" }, null, -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "d-flex" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-white opacity-10" }, null, -1)
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showConfirmModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConfirmModal = false))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmModal = false))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)))
                }, "Confirmar")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rota.Pedidos, (pedido, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["col-auto p-2", ['step', _ctx.getClassByStatus(pedido.status_entrega),  pedido === 'Intervalo' ? 'interval' : '']]),
                key: pedido.ordem,
                onClick: ($event: any) => (_ctx.setCenterItem(pedido))
              }, [
                _createElementVNode("span", {
                  style: {"font-size":"14px","cursor":"pointer"},
                  onClick: ($event: any) => (_ctx.gotoPedido(pedido))
                }, _toDisplayString(pedido.numero_pedido), 9, _hoisted_16)
              ], 10, _hoisted_15))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("ul", _hoisted_22, [
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("span", _hoisted_28, [
                            _createTextVNode(_toDisplayString(_ctx.rota.Veiculo.marca) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.rota.Veiculo.modelo), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('/veiculos'))),
                          class: "my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
                        }, _hoisted_31)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          (!_ctx.rota.editingOperador)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!_ctx.rota.operador_id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                      _hoisted_38,
                                      _createElementVNode("i", {
                                        class: "fas fa-user-edit text-secondary",
                                        style: {"cursor":"pointer"},
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rota.editingOperador = true))
                                      })
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                      (_ctx.rota.operador.is_update)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _hoisted_43))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(_ctx.rota.operador?.nome_completo), 1)
                                    ]))
                              ], 64))
                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                class: "form-control",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rota.operador_id) = $event)),
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alocarMotorista(_ctx.rota.Veiculo.id, _ctx.rota.id, _ctx.rota.operador_id, _ctx.rota  )))
                              }, [
                                _hoisted_44,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.motoristas, (m) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: m.id,
                                    value: m.id
                                  }, _toDisplayString(m.nome_completo), 9, _hoisted_45))
                                }), 128))
                              ], 544)), [
                                [_vModelSelect, _ctx.rota.operador_id]
                              ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("button", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goTo('/motoristas'))),
                          class: "my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
                        }, _hoisted_48)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("span", _hoisted_54, [
                            _createTextVNode(_toDisplayString(_ctx.rota.Pedidos.length) + " Serviços ", 1),
                            _createElementVNode("strong", null, " em " + _toDisplayString(_ctx.rota.distance) + " Km", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goTo('/pedidos'))),
                          class: "my-auto btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right"
                        }, _hoisted_57)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "flexSwitchCheckDefault",
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.salvarRota(_ctx.rota))),
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rota.fixa) = $event))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.rota.fixa]
                          ]),
                          _hoisted_62
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        (!_ctx.rota.confirmada)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "flexSwitchCheckDefault",
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.salvarRota(_ctx.rota))),
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rota.confirmada) = $event))
                              }, null, 544), [
                                [_vModelCheckbox, _ctx.rota.confirmada]
                              ]),
                              _hoisted_67
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_68, "CONFIRMADA"))
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleRoute(_ctx.rota))),
                          class: "text-center shadow icon icon-shape icon-sm bg-gradient-warning me-3"
                        }, _hoisted_72)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.removerRota(_ctx.rota))),
                          class: "text-center shadow icon icon-shape icon-sm bg-gradient-danger me-3"
                        }, _hoisted_75)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}